import React from 'react'
import { ColumnTable } from '../Table/types/TableTypes'

type TableHeadProps = {
  columns: ColumnTable[]
}

export const TableCollapsableHead = ({ columns }: TableHeadProps) => {
  return (
    <thead>
      <tr>
        {columns.map((col, i) => {
          const thProps =
            typeof col.thProps === 'function'
              ? col.thProps({ column: col, index: i })
              : col.thProps
          return (
            <th
              className={col.thClassName || ''}
              key={`header_${i}`}
              style={{
                minWidth: col.width ? col.width : '',
                width: col.width ? col.width : ''
              }}
              {...thProps}
            >
              {col.headerText}
            </th>
          )
        })}
      </tr>
    </thead>
  )
}
